import { msg } from "@lingui/core/macro";
import { I18nContext } from "@lingui/react";

import { getSemanticScore, SemanticScore } from "./scoreUtils";
import { isWithinRange } from "./utils";
import COACHING_BENCHMARKS from "../constants/coachingBenchmarks";

const WPM_LABEL_LOWER = msg({
  message: "wpm",
  comment: "Abbreviation of 'words per minute'",
});

export const WPM_LABEL_UPPER = msg({
  message: "WPM",
  comment: "Abbreviation of 'Words Per Minute'",
});

export const getWpmLabel = (wpm: number, _: I18nContext["_"]): string =>
  `${wpm} ${_(WPM_LABEL_LOWER)}`;

export const isWpmWithinRecommendedRange = (wpm: number) =>
  isWithinRange(
    wpm,
    [COACHING_BENCHMARKS.wpm.min, COACHING_BENCHMARKS.wpm.max],
    { inclusiveEnd: true },
  );

export const getWpmSemanticScore = (
  rate: number | null | undefined,
): SemanticScore =>
  rate == null
    ? "unknown"
    : isWpmWithinRecommendedRange(rate)
      ? "positive"
      : "negative";

export const getFillerWordsSemanticScore = (
  rate: number | null,
): SemanticScore =>
  getSemanticScore(
    rate ? Math.round(rate) : rate,
    COACHING_BENCHMARKS.fillerWordsThresholds,
    { inverted: true, inclusive: false },
  );

export const getNonInclusiveTermsSemanticScore = (
  count: number | null,
): SemanticScore =>
  getSemanticScore(count, COACHING_BENCHMARKS.nonInclusiveTermThresholds, {
    inverted: true,
    inclusive: false,
  });

export const getInterruptionsSemanticScore = (
  count: number | null,
): SemanticScore =>
  getSemanticScore(count, COACHING_BENCHMARKS.interruptionThresholds, {
    inverted: true,
    inclusive: false,
  });

export const getQuestionsAskedSemanticScore = (
  count: number | null,
): SemanticScore => ((count ?? 0) >= 1 ? "positive" : "unknown");
